(() => {
  const init = (root) => {
    if (root.dataset.gamingDirectoryReady === 'true') return;
    root.dataset.gamingDirectoryReady = 'true';

    const filters = Array.from(root.querySelectorAll('[data-gaming-filter]'));
    const items = Array.from(root.querySelectorAll('[data-gaming-item]'));
    const heading = root.querySelector('[data-gaming-results-heading]');
    const status = root.querySelector('[data-gaming-results-status]');
    const searchForm = root.querySelector('[data-gaming-search-form]');
    const searchInput = root.querySelector('[data-gaming-search]');
    const clearButton = root.querySelector('[data-gaming-search-clear]');
    const noResults = root.querySelector('[data-gaming-no-results]');

    if (!filters.length || !items.length) return;

    let activeBrand = 'all';
    let activeLabel = 'All Gaming Skins';

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const applyFilters = () => {
      const query = normalize(searchInput?.value);
      let visible = 0;

      items.forEach((item) => {
        const card = item.querySelector('[data-search]');
        const searchableText = normalize(`${card?.dataset.search || ''} ${item.dataset.gamingBrand || ''}`);
        const matchesBrand = activeBrand === 'all' || item.dataset.gamingBrand === activeBrand;
        const matchesSearch = !query || searchableText.includes(query);
        const show = matchesBrand && matchesSearch;

        item.hidden = !show;
        if (show) visible += 1;
      });

      filters.forEach((button) => {
        const active = button.dataset.gamingFilter === activeBrand;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (heading) {
        heading.textContent = activeBrand === 'all' ? 'All Gaming Skins' : `${activeLabel} Gaming Skins`;
      }
      if (status) {
        const searchStatus = query ? ` matching “${searchInput.value.trim()}”` : '';
        status.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}${searchStatus}, newest first`;
      }
      if (clearButton) clearButton.hidden = !query;
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeBrand = button.dataset.gamingFilter || 'all';
        activeLabel = button.dataset.label || 'All Gaming Skins';
        applyFilters();
      });
    });

    searchForm?.addEventListener('submit', (event) => event.preventDefault());
    searchInput?.addEventListener('input', applyFilters);
    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      applyFilters();
      searchInput.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sw-gaming-directory]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
